/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const styles = {
  textBottomSpacing: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
  bulletPoint: () => css`
    padding: var(--cds-spacing-50) var(--cds-spacing-100) var(--cds-spacing-50) var(--cds-spacing-50);
  `,
};

const getVeteranStatusBulletPointItemsText = () => [
  _t(
    'A “disabled veteran” is one of the following: a veteran of the U.S. military, ground, naval or air service who is entitled to compensation (or who but for the receipt of military retired pay would be entitled to compensation) under laws administered by the Secretary of Veterans Affairs; or a person who was discharged or released from active duty because of a service-connected disability.'
  ),
  _t(
    'A “recently separated veteran” means any veteran during the three-year period beginning on the date of such veteran’s discharge or release from active duty in the U.S. military, ground, naval, or air service.'
  ),
  _t(
    'An “active duty wartime or campaign badge veteran” means a veteran who served on active duty in the U.S. military, ground, naval or air service during a war, or in a campaign or expedition for which a campaign badge has been authorized under the laws administered by the Department of Defense.'
  ),
  _t(
    'An “Armed forces service medal veteran” means a veteran who, while serving on active duty in the U.S. military, ground, naval or air service, participated in a United States military operation for which an Armed Forces service medal was awarded pursuant to Executive Order 12985.'
  ),
];

const VeteranStatusInformation = () => {
  const veteranStatusBulletPointItemsText = getVeteranStatusBulletPointItemsText();
  return (
    <div>
      <Typography2 component="p" css={styles.textBottomSpacing}>
        {_t(
          'If you believe you belong to any of the categories of protected veterans listed below, please indicate by making the appropriate selection. Recruiters may be government contractors to whom the Vietnam Era Veterans Readjustment Assistance Act (VEVRAA) may apply. This information is requested in order to expand the effectiveness of the outreach and positive recruitment efforts pursuant to VEVRAA. Classification of protected categories is as follows:'
        )}
      </Typography2>
      <Typography2 component="p">
        {veteranStatusBulletPointItemsText.map((text) => (
          <div css={styles.textBottomSpacing}>
            <span css={styles.bulletPoint} aria-hidden={true}>
              •
            </span>
            {text}
          </div>
        ))}
      </Typography2>
    </div>
  );
};

export default VeteranStatusInformation;
